/* SingleSignOnRenderer.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const TextControl = uiCore.Control.Textfield.InputText;
const InputRadioControl = uiCore.Control.OptionSelection.Single.InputRadio;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const SingleCombobox = uiCore.Control.OptionSelection.Single.ComboBox;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const TextareaControl = uiCore.Control.Textfield.Textarea;

const UserManagementControls = {
    _samlUsersOnly: {
        saml: "_samlUsersOnly",
        oauth: "_oauthUsersOnly",
    },
    _samlDisableLocalLoginPage: {
        saml: "_samlDisableLocalLoginPage",
        oauth: "_oauthDisableLocalLoginPage",
    },
    _userNameAttr: {
        saml: "_userNameAttr",
        oauth: "_oauthUserNameAttr",
    },
    _email: {
        saml: "_email",
        oauth: "_oauthEmail",
    },
    _first: {
        saml: "_first",
        oauth: "_oauthFirst",
    },
    _last: {
        saml: "_last",
        oauth: "_oauthLast",
    },
    _actionGroup: {
        saml: "_actionGroup",
        oauth: "_oauthActionGroup",
    },
    _defaultActionGroupId: {
        saml: "_defaultActionGroupId",
        oauth: "_oauthDefaultActionGroupId",
    },
    // _orgVisibility: {
    //     saml: "_orgVisibility",
    //     oauth: "_oauthOrgVisibility"
    // },
    // _defaultOrgVisibility: {
    //     saml: "_defaultOrgVisibility",
    //     oauth: "_oauthDefaultOrgVisibility"
    // }
};
class SingleSignOnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("single-sign-on-gl");
        this._rootElem.component = model;

        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "Single Sign-On";
        this._mainContainer = document.createElement("container-main");

        this._optionsFragment = document.createElement("div");
        this._optionsFragment.classList.add("sso-mechanism-container");
        const ssoMechanismLabel = document.createElement("label");
        ssoMechanismLabel.classList.add("sso-mechanism-label");
        ssoMechanismLabel.innerText = "User Single Sign-On Mechanism";

        this._ssoMechanismRadio = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
        });
        this._optionsFragment.appendChild(ssoMechanismLabel);
        this._optionsFragment.appendChild(this._ssoMechanismRadio._renderer.getRootElement());

        this._buttonGroupContainer = document.createElement("button-group-container");
        this._saveButton = new ButtonControl({
            id: "save",
            label: "Save",
            disabled: true,
            active: true,
            darkTheme: true,
        });
        this._cancelButton = new ButtonControl({id: "cancel", label: "Cancel", disabled: true});
        this._buttonGroupContainer.appendChild(this._cancelButton.renderer.getRootElement());
        this._buttonGroupContainer.appendChild(this._saveButton.renderer.getRootElement());

        this._EmailRegex = new RegExp(
            /^(.*\s<(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))>)|((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/
        );
        this._GlURLRegex = new RegExp(
            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w\-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[.!/\\\w]*))?)/
        ); // eslint-disable-line

        this._isSamlDirty = false;

        this._registerListeners();
    }

    get rootElement() {
        return this.getRootElement();
    }
    get model() {
        return this.getModel();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._ssoMechanismRadio.on(
            "UserValue",
            (this._ssoMechanismSelectChange = this._ssoMechanismSelectChange.bind(this))
        );
        this._saveButton.on(
            "UserClick",
            (this._submitSSOAction = this._submitSSOAction.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._cancelSamlAction = this._cancelSamlAction.bind(this))
        );
    }

    _registerSAMLListeners() {
        this._samlConfigType.on(
            "UserValue",
            (this._samlViewChangeChange = this._samlViewChangeChange.bind(this))
        );
    }

    _registerOauthListeners() {
        this._oauthConfigType.on(
            "UserValue",
            (this._oauthViewChangeChange = this._oauthViewChangeChange.bind(this))
        );
    }

    _unregisterSAMLListeners() {
        this._samlConfigType &&
            this._samlConfigType.removeListener("UserValue", this._samlViewChangeChange);
    }

    _unregisterOauthListeners() {
        this._oauthConfigType &&
            this._oauthConfigType.removeListener("UserValue", this._oauthViewChangeChange);
    }

    _registerSAMLBasicViewListeners() {
        this._entryPointField.on(
            "UserValue",
            (this._onEntryPointFieldChange = this._onEntryPointFieldChange.bind(this))
        );
        this._issuerField.on(
            "UserValue",
            (this._onIssuerFieldChange = this._onIssuerFieldChange.bind(this))
        );
        this._nameIdFormatField.on(
            "UserValue",
            (this._onNameIdFormatFieldChange = this._onNameIdFormatFieldChange.bind(this))
        );
        this._certField.on(
            "UserValue",
            (this._oncertFieldChange = this._oncertFieldChange.bind(this))
        );
        this._descripPvtKeyCredField.on(
            "UserValue",
            (this._onDescripPvtKeyField = this._onDescripPvtKeyField.bind(this))
        );
    }

    _registerOauthBasicViewListeners() {
        this._oauthAuthorizationURLField.on(
            "UserValue",
            (this._onOauthAuthorizationURLFieldChange =
                this._onOauthAuthorizationURLFieldChange.bind(this))
        );
        this._oauthClientIdField.on(
            "UserValue",
            (this._onOauthClientIdFieldChange = this._onOauthClientIdFieldChange.bind(this))
        );
        this._oauthClientSecretCredField.on(
            "UserValue",
            (this._onOauthClientSecretFieldChange = this._onOauthClientSecretFieldChange.bind(this))
        );
        this._oauthPkceField.on(
            "UserValue",
            (this._onOauthPkceFieldChange = this._onOauthPkceFieldChange.bind(this))
        );
        this._oauthScopeField.on(
            "UserValue",
            (this._onOauthScopeFieldChange = this._onOauthScopeFieldChange.bind(this))
        );
        this._oauthTokenURLField.on(
            "UserValue",
            (this._onOauthTokenURLFieldChange = this._onOauthTokenURLFieldChange.bind(this))
        );
        this._oauthUserProfileURLField.on(
            "UserValue",
            (this._onOauthUserProfileURLFieldChange =
                this._onOauthUserProfileURLFieldChange.bind(this))
        );
    }

    _unregisterSAMLBasicViewListeners() {
        this._entryPointField &&
            this._entryPointField.removeListener("UserValue", this._onEntryPointFieldChange);
        this._issuerField &&
            this._issuerField.removeListener("UserValue", this._onIssuerFieldChange);
        this._nameIdFormatField &&
            this._nameIdFormatField.removeListener("UserValue", this._onNameIdFormatFieldChange);
        this._certField && this._certField.removeListener("UserValue", this._oncertFieldChange);
        this._descripPvtKeyCredField &&
            this._descripPvtKeyCredField.removeListener("UserValue", this._onDescripPvtKeyField);
    }

    _unregisterOauthBasicViewListeners() {
        this._oauthAuthorizationURLField &&
            this._oauthAuthorizationURLField.removeListener(
                "UserValue",
                this._onOauthAuthorizationURLFieldChange
            );
        this._oauthClientIdField &&
            this._oauthClientIdField.removeListener("UserValue", this._onOauthClientIdFieldChange);
        this._oauthClientSecretCredField &&
            this._oauthClientSecretCredField.removeListener(
                "UserValue",
                this._onOauthClientSecretFieldChange
            );
        this._oauthPkceField &&
            this._oauthPkceField.removeListener("UserValue", this._onOauthPkceFieldChange);
        this._oauthScopeField &&
            this._oauthScopeField.removeListener("UserValue", this._onOauthScopeFieldChange);
        this._oauthTokenURLField &&
            this._oauthTokenURLField.removeListener("UserValue", this._onOauthTokenURLFieldChange);
        this._oauthUserProfileURLField &&
            this._oauthUserProfileURLField.removeListener(
                "UserValue",
                this._onOauthUserProfileURLFieldChange
            );
    }

    _registerAdvancedSamlListener() {
        this._samlAdvArea.on(
            "UserValue",
            (this._onSamlAdvAreaChange = this._onSamlAdvAreaChange.bind(this))
        );
    }

    _registerAdvancedOauthListener() {
        this._oauthAdvArea.on(
            "UserValue",
            (this._onOauthAdvAreaChange = this._onOauthAdvAreaChange.bind(this))
        );
    }

    _unregisterAdvancedSamlListener() {
        this._samlAdvArea &&
            this._samlAdvArea.removeListener("UserValue", this._onSamlAdvAreaChange);
    }

    _unregisterAdvancedOauthListener() {
        this._oauthAdvArea &&
            this._oauthAdvArea.removeListener("UserValue", this._onOauthAdvAreaChange);
    }

    _registerUserMgmtViewListeners() {
        this._samlUsersOnly.on(
            "UserValue",
            (this._onSamlUsersOnlyChange = this._onSamlUsersOnlyChange.bind(this))
        );
        this._samlDisableLocalLoginPage.on(
            "UserValue",
            (this._onSamlDisableLocalLoginPageChange =
                this._onSamlDisableLocalLoginPageChange.bind(this))
        );
        this._userNameAttr.on(
            "UserValue",
            (this._onUserNameAttrChange = this._onUserNameAttrChange.bind(this))
        );
        this._email.on("UserValue", (this._onEmailChange = this._onEmailChange.bind(this)));
        this._first.on("UserValue", (this._onFirstChange = this._onFirstChange.bind(this)));
        this._last.on("UserValue", (this._onLastChange = this._onLastChange.bind(this)));
        this._actionGroup.on(
            "UserValue",
            (this._onActionGroupChange = this._onActionGroupChange.bind(this))
        );
        this._defaultActionGroupId.on(
            "UserValue",
            (this._onDefaultActionGroupIdChange = this._onDefaultActionGroupIdChange.bind(this))
        );
        // this._orgVisibility.on("UserValue", this._onOrgVisibilityChange = this._onOrgVisibilityChange.bind(this));
        // this._defaultOrgVisibility.on("UserValue", this._onDefaultOrgVisibility = this._onDefaultOrgVisibility.bind(this));
    }

    _registerOauthUserMgmtViewListeners() {
        this._oauthUsersOnly.on(
            "UserValue",
            (this._onOauthUsersOnlyChange = this._onOauthUsersOnlyChange.bind(this))
        );
        this._oauthDisableLocalLoginPage.on(
            "UserValue",
            (this._onOauthDisableLocalLoginPageChange =
                this._onOauthDisableLocalLoginPageChange.bind(this))
        );
        this._oauthUserNameAttr.on(
            "UserValue",
            (this._onOauthUserNameAttrChange = this._onOauthUserNameAttrChange.bind(this))
        );
        this._oauthEmail.on(
            "UserValue",
            (this._onOauthEmailChange = this._onOauthEmailChange.bind(this))
        );
        this._oauthFirst.on(
            "UserValue",
            (this._onOauthFirstChange = this._onOauthFirstChange.bind(this))
        );
        this._oauthLast.on(
            "UserValue",
            (this._onOauthLastChange = this._onOauthLastChange.bind(this))
        );
        this._oauthActionGroup.on(
            "UserValue",
            (this._onOauthActionGroupChange = this._onOauthActionGroupChange.bind(this))
        );
        this._oauthDefaultActionGroupId.on(
            "UserValue",
            (this._onOauthDefaultActionGroupIdChange =
                this._onOauthDefaultActionGroupIdChange.bind(this))
        );
        // this._oauthOrgVisibility.on("UserValue", this._onOauthOrgVisibilityChange = this._onOauthOrgVisibilityChange.bind(this));
        // this._oauthDefaultOrgVisibility.on("UserValue", this._onOauthDefaultOrgVisibility = this._onOauthDefaultOrgVisibility.bind(this));
    }

    _unregisterUserMgmtViewListeners() {
        this._samlUsersOnly &&
            this._samlUsersOnly.removeListener("UserValue", this._onSamlUsersOnlyChange);
        this._samlDisableLocalLoginPage &&
            this._samlDisableLocalLoginPage.removeListener(
                "UserValue",
                this._onSamlDisableLocalLoginPageChange
            );
        this._userNameAttr &&
            this._userNameAttr.removeListener("UserValue", this._onUserNameAttrChange);
        this._email && this._email.removeListener("UserValue", this._onEmailChange);
        this._first && this._first.removeListener("UserValue", this._onFirstChange);
        this._last && this._last.removeListener("UserValue", this._onLastChange);
        this._actionGroup &&
            this._actionGroup.removeListener("UserValue", this._onActionGroupChange);
        this._defaultActionGroupId &&
            this._defaultActionGroupId.removeListener(
                "UserValue",
                this._onDefaultActionGroupIdChange
            );
        // this._orgVisibility && this._orgVisibility.removeListener("UserValue", this._onOrgVisibilityChange);
        // this._defaultOrgVisibility && this._defaultOrgVisibility.removeListener("UserValue", this._onDefaultOrgVisibility);
    }

    _unregisterOauthUserMgmtViewListeners() {
        this._oauthUsersOnly &&
            this._oauthUsersOnly.removeListener("UserValue", this._onOauthUsersOnlyChange);
        this._oauthDisableLocalLoginPage &&
            this._oauthDisableLocalLoginPage.removeListener(
                "UserValue",
                this._onOauthDisableLocalLoginPageChange
            );
        this._oauthUserNameAttr &&
            this._oauthUserNameAttr.removeListener("UserValue", this._onOauthUserNameAttrChange);
        this._oauthEmail && this._oauthEmail.removeListener("UserValue", this._onOauthEmailChange);
        this._oauthFirst && this._oauthFirst.removeListener("UserValue", this._onOauthFirstChange);
        this._oauthLast && this._oauthLast.removeListener("UserValue", this._onOauthLastChange);
        this._oauthActionGroup &&
            this._oauthActionGroup.removeListener("UserValue", this._onOauthActionGroupChange);
        this._oauthDefaultActionGroupId &&
            this._oauthDefaultActionGroupId.removeListener(
                "UserValue",
                this._onOauthDefaultActionGroupIdChange
            );
        // this._oauthOrgVisibility && this._oauthOrgVisibility.removeListener("UserValue", this._onOauthOrgVisibilityChange);
        // this._oauthDefaultOrgVisibility && this._oauthDefaultOrgVisibility.removeListener("UserValue", this._onOauthDefaultOrgVisibility);
    }

    _unregisterListeners() {
        this._ssoMechanismRadio.removeListener("UserClick", this._ssoMechanismSelectChange);
        this._saveButton.removeListener("UserClick", this._submitSSOAction);
        this._cancelButton.removeListener("UserClick", this._cancelSamlAction);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    getRootElement() {
        return this._rootElem;
    }
    getModel() {
        return this._model;
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this._model) {
            return this._model
                .whenModelIsReady()
                .then(() => {
                    if (this._rootElem) {
                        this._rootElem.innerHTML = "";
                        this._rootElem.appendChild(this._headerElem);
                        this._rootElem.appendChild(this._mainContainer);
                        this._mainContainer.appendChild(this._optionsFragment);
                        this._rootElem.appendChild(this._buttonGroupContainer);

                        this._ssoMechanismRadio.setOptions([
                            {
                                label: "Disabled",
                                value: "disabled",
                            },
                            {
                                label: "SAML",
                                value: "saml",
                                disabled: this._model._isLdapRadiusEnabled,
                            },
                            {
                                label: "OAuth",
                                value: "oauth",
                                disabled: this._model._isLdapRadiusEnabled,
                            },
                        ]);
                        this._ssoMechanismRadio.setValue("disabled");

                        this._setSSOMechanismSelect();

                        // this._setInitialSSOMethodValue();

                        this._isSamlValid = true;
                        // this._isSmtpValid = true; // Setting to true after initial button state
                        // this._isProxyValid = true; // so that they dont interfere with dirty state button states
                        // if(this._model._myUserInfo.authorizedActions.indexOf("configWrite") < 0) {
                        //     this._disableSmtpFields();
                        // }
                    }
                })
                .catch(console.error);
        }
    }

    _setSSOMechanismSelect() {
        this._ssoMechanismRadio.setValue(this._model._updatedAuthSelection);
        this._ssoMechanismSelectChange(this._model._updatedAuthSelection, true);
    }

    shutdown() {
        this._unregisterListeners();
        this._unregisterSAMLListeners();
        this._unregisterOauthListeners();
        this._unregisterSAMLBasicViewListeners();
        this._unregisterOauthBasicViewListeners();
        this._unregisterAdvancedSamlListener();
        this._unregisterAdvancedOauthListener();
        this._unregisterUserMgmtViewListeners();
        this._unregisterOauthUserMgmtViewListeners();
        this._controls = [
            this._ssoMechanismRadio,
            this._samlConfigType,
            this._entryPointField,
            this._issuerField,
            this._nameIdFormatField,
            this._certField,
            this._descripPvtKeyCredField,
            this._samlUsersOnly,
            this._samlDisableLocalLoginPage,
            this._userNameAttr,
            this._email,
            this._first,
            this._last,
            this._actionGroup,
            this._defaultActionGroupId,
            // this._orgVisibility,
            // this._defaultOrgVisibility
            this._oauthConfigType,
            this._oauthAuthorizationURLField,
            this._oauthClientIdField,
            this._oauthClientSecretCredField,
            this._oauthPkceField,
            this._oauthScopeField,
            this._oauthTokenURLField,
            this._oauthUserProfileURLField,
            this._oauthUsersOnly,
            this._oauthDisableLocalLoginPage,
            this._oauthUserNameAttr,
            this._oauthEmail,
            this._oauthFirst,
            this._oauthLast,
            this._oauthActionGroup,
            this._oauthDefaultActionGroupId,
            // this._oauthOrgVisibility,
            // this._oauthDefaultOrgVisibility
        ];
        return Promise.all(_.invokeMap(this._controls, "shutdown")).then(() => {
            this._rootElem.remove();
            this._headerElem = undefined;
            this._rootElem = undefined;
            this._mainContainer = undefined;

            this._optionsFragment = undefined;
            this._ssoMechanismRadio = undefined;
            this._buttonGroupContainer = undefined;
            this._saveButton = undefined;
            this._cancelButton = undefined;
            this._EmailRegex = undefined;
            this._GlURLRegex = undefined;
            this._isSamlDirty = undefined;

            this._samlConfigType = undefined;
            this._entryPointField = undefined;
            this._issuerField = undefined;
            this._nameIdFormatField = undefined;
            this._certField = undefined;
            this._descripPvtKeyCredField = undefined;
            this._samlUsersOnly = undefined;
            this._samlDisableLocalLoginPage = undefined;
            this._userNameAttr = undefined;
            this._email = undefined;
            this._first = undefined;
            this._last = undefined;
            this._actionGroup = undefined;
            this._defaultActionGroupId = undefined;
            // this._orgVisibility = undefined;
            // this._defaultOrgVisibility = undefined;

            this._oauthConfigType = undefined;
            this._oauthAuthorizationURLField = undefined;
            this._oauthClientIdField = undefined;
            this._oauthClientSecretCredField = undefined;
            this._oauthPkceField = undefined;
            this._oauthScopeField = undefined;
            this._oauthTokenURLField = undefined;
            this._oauthUserProfileURLField = undefined;
            this._oauthUsersOnly = undefined;
            this._oauthDisableLocalLoginPage = undefined;
            this._oauthUserNameAttr = undefined;
            this._oauthEmail = undefined;
            this._oauthFirst = undefined;
            this._oauthLast = undefined;
            this._oauthActionGroup = undefined;
            this._oauthDefaultActionGroupId = undefined;
            // this._oauthOrgVisibility = undefined;
            // this._oauthDefaultOrgVisibility = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderFormPair(labelName, title, component) {
        const parent = document.createElement("div");
        parent.classList.add("field-container");
        let labelElem = document.createElement("label");
        labelElem.innerText = labelName;
        labelElem.setAttribute("title", title);
        let cmpntElem = component.renderer.getRootElement();
        parent.appendChild(labelElem);
        parent.appendChild(cmpntElem);

        return parent;
    }

    _createSection(content, options = {}) {
        const section = document.createElement("section");
        section.className = options.className || "";
        section.classList.toggle("bordered", !!options.bordered);

        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            section.appendChild(title);
        }
        section.appendChild(content);
        return section;
    }

    _createSAMLSectionDOM() {
        this._SAMLContent = document.createDocumentFragment();

        this._sFormElem = document.createElement("div");
        this._sFormElem.classList.add("saml-form", "settings-form");

        this._samlConfigType = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "Basic",
                    tooltip: "Enter SAML settings for Gluware Authentication in the form",
                    value: false,
                },
                {
                    label: "Advanced",
                    tooltip: "Paste settings for SAML in a JSON configuration",
                    value: true,
                },
            ],
            value: false,
        });

        this._sFormElem.appendChild(this._samlConfigType._renderer._rootElem);
        this._SAMLContent.appendChild(this._sFormElem);

        this._samlSection = this._createSection(this._SAMLContent, {
            title: "SAML Settings",
            className: "saml-section",
            bordered: true,
        });

        this._registerSAMLListeners();

        this._mainContainer.appendChild(this._samlSection);
    }

    _createOauthSectionDOM() {
        this._oauthContent = document.createDocumentFragment();

        this._oFormElem = document.createElement("div");
        this._oFormElem.classList.add("oauth-form", "settings-form");

        this._oauthConfigType = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "Basic",
                    tooltip: "Enter OAuth settings for Gluware Authentication in the form",
                    value: false,
                },
                {
                    label: "Advanced",
                    tooltip: "Paste settings for OAuth in a JSON configuration",
                    value: true,
                },
            ],
            value: false,
        });

        this._oFormElem.appendChild(this._oauthConfigType._renderer._rootElem);
        this._oauthContent.appendChild(this._oFormElem);

        this._oauthSection = this._createSection(this._oauthContent, {
            title: "OAuth Settings",
            className: "oauth-section",
            bordered: true,
        });

        this._registerOauthListeners();

        this._mainContainer.appendChild(this._oauthSection);
    }

    _createSAMLBasicView() {
        this._samlBasicContainer = document.createElement("div");
        this._samlBasicContainer.classList.add("saml-basic-form", "hide");

        this._entryPointField = new TextControl({
            darkTheme: true,
            label: "Entry Point",
            title: "The URL used to initiate a Single Sign On (SSO) with the identity provider",
        });

        this._issuerField = new TextControl({
            darkTheme: true,
            label: "Issuer",
            title: "The URL of the identity provider",
        });

        this._nameIdFormatField = new TextControl({
            darkTheme: true,
            label: "Name ID Format",
            value: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress",
            title: "The format for the user identity that will be sent by the identity provider. The default is an email address",
        });

        this._certField = new TextareaControl({
            darkTheme: true,
            label: "Certificate",
        });

        this._descripPvtKeyCredField = new SingleCombobox({
            darkTheme: true,
            label: "Decryption Private Key Credential",
            title: "Optional private key used to secure the communication between the identity provider and Gluware",
        });
        this._descripPvtKeyCredField.setOptions(this._model._credentialsList);

        this._samlBasicContainer.appendChild(
            this._renderFormPair(
                "Entry Point",
                "The URL used to initiate a Single Sign On (SSO) with the identity provider",
                this._entryPointField
            )
        );
        this._samlBasicContainer.appendChild(
            this._renderFormPair("Issuer", "The URL of the identity provider", this._issuerField)
        );
        this._samlBasicContainer.appendChild(
            this._renderFormPair(
                "Name ID Format",
                "The format for the user identity that will be sent by the identity provider. The default is an email address",
                this._nameIdFormatField
            )
        );
        this._samlBasicContainer.appendChild(
            this._renderFormPair(
                "Certificate",
                "The public X.509 certificate in Base-64 encoded format for the identity provider",
                this._certField
            )
        );
        this._samlBasicContainer.appendChild(
            this._renderFormPair(
                "Decryption Private Key Credential",
                "Optional private key used to secure the communication between the identity provider and Gluware",
                this._descripPvtKeyCredField
            )
        );

        this._registerSAMLBasicViewListeners();

        this._samlSection.appendChild(this._samlBasicContainer);
    }

    _createOauthBasicView() {
        this._oauthBasicContainer = document.createElement("div");
        this._oauthBasicContainer.classList.add("saml-basic-form", "hide");
        this._oauthAuthorizationURLField = new TextControl({
            darkTheme: true,
            label: "Authorization URL",
            title: "The URL used to initiate a Single Sign On (SSO) with the identity provider",
        });

        this._oauthClientIdField = new TextControl({
            darkTheme: true,
            label: "Client ID",
            title: "Public identifier generated by the identity provider to uniquely identify Gluware",
        });

        this._oauthClientSecretCredField = new SingleCombobox({
            darkTheme: true,
            label: "Client Credential",
            title: "Shared secret generated by the identity provider",
        });
        this._oauthClientSecretCredField.setOptions(this._model._credentialsList);

        this._oauthPkceField = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "PKCE",
            title: "Check the box if using Proof Key for Code Exchange to provide additional security",
            disabled: false,
        });

        this._oauthScopeField = new TextControl({
            darkTheme: true,
            label: "Scope",
            title: "The scope assigned to users that allows them to sign in to Gluware using OAuth2 as defined in the identity provider",
        });

        this._oauthTokenURLField = new TextControl({
            darkTheme: true,
            label: "Token Url",
            title: "The URL used to request access tokens from the identity provider",
        });

        this._oauthUserProfileURLField = new TextControl({
            darkTheme: true,
            label: "User Profile URL",
            title: "The URL to retrieve user profiles from the identity provider",
        });

        this._oauthBasicContainer.appendChild(
            this._renderFormPair(
                "Authorization URL",
                "The URL used to initiate a Single Sign On (SSO) with the identity provider",
                this._oauthAuthorizationURLField
            )
        );
        this._oauthBasicContainer.appendChild(
            this._renderFormPair(
                "Client ID",
                "Public identifier generated by the identity provider to uniquely identify Gluware",
                this._oauthClientIdField
            )
        );
        this._oauthBasicContainer.appendChild(
            this._renderFormPair(
                "Client Secret",
                "Shared secret generated by the identity provider",
                this._oauthClientSecretCredField
            )
        );
        this._oauthBasicContainer.appendChild(this._oauthPkceField._renderer._rootElem);
        this._oauthBasicContainer.appendChild(
            this._renderFormPair(
                "Scope",
                "The scope assigned to users that allows them to sign in to Gluware using OAuth2 as defined in the identity provider",
                this._oauthScopeField
            )
        );
        this._oauthBasicContainer.appendChild(
            this._renderFormPair(
                "Token Url",
                "The URL used to request access tokens from the identity provider",
                this._oauthTokenURLField
            )
        );
        this._oauthBasicContainer.appendChild(
            this._renderFormPair(
                "User Profile URL",
                "The URL to retrieve user profiles from the identity provider",
                this._oauthUserProfileURLField
            )
        );

        this._registerOauthBasicViewListeners();

        this._oauthSection.appendChild(this._oauthBasicContainer);
    }

    _createSAMLAdvancedView() {
        this._samlAdvancedContainer = document.createElement("div");
        this._samlAdvancedContainer.classList.add("saml-advanced-form", "hide");

        this._samlAdvArea = new TextareaControl({
            darkTheme: true,
            value: JSON.stringify(
                _.omit(this._model._updatedSamlOptions, "advanced"),
                undefined,
                4
            ),
        });

        this._samlAdvancedContainer.appendChild(
            this._renderFormPair(
                "Advanced Configuration",
                "Advanced Configuration",
                this._samlAdvArea
            )
        );
        this._registerAdvancedSamlListener();
        this._samlSection.appendChild(this._samlAdvancedContainer);
    }

    _createOauthAdvancedView() {
        this._oauthAdvancedContainer = document.createElement("div");
        this._oauthAdvancedContainer.classList.add("oauth-advanced-form", "hide");

        this._oauthAdvArea = new TextareaControl({
            darkTheme: true,
            value: JSON.stringify(
                _.omit(this._model._updatedOauthOptions, "advanced"),
                undefined,
                4
            ),
        });

        this._oauthAdvancedContainer.appendChild(
            this._renderFormPair(
                "Advanced Configuration",
                "Advanced Configuration",
                this._oauthAdvArea
            )
        );
        this._registerAdvancedOauthListener();
        this._oauthSection.appendChild(this._oauthAdvancedContainer);
    }

    _createUserManagementView() {
        this._userManagementContainer = document.createElement("div");
        this._userManagementContainer.classList.add("user-management-form");

        this._samlUsersOnly = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Disable creation of local users",
            title: "Limits new users to only those in SAML/Oauth. Any existing users remain",
            disabled: false,
        });

        this._samlDisableLocalLoginPage = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Disable local login page",
            title: "Disables the login page navigation through direct link.",
            disabled: false,
        });

        this._userNameAttr = new TextControl({
            darkTheme: true,
            label: "Username Attribute",
            title: "The SAML/Oauth attribute name where the username is stored in a user entry. Additional entries can be used if proxies are needed to access a device",
        });

        this._email = new TextControl({
            darkTheme: true,
            label: "Email Attribute",
            title: "The SAML/Oauth attribute that contains the user's email address; for example, mail.",
        });

        this._first = new TextControl({
            darkTheme: true,
            label: "First Name Attribute",
            title: "The SAML/Oauth attribute that contains the user’s first name",
        });

        this._last = new TextControl({
            darkTheme: true,
            label: "Last Name Attribute",
            title: "The SAML/Oauth attribute that contains the user’s last name",
        });

        this._actionGroup = new TextControl({
            darkTheme: true,
            label: "Role Attribute",
            title: "Optional SAML/Oauth attribute used to set the role; for example, memberOf. If Role Attribute is assigned, the role cannot be modified in Gluware",
        });

        this._defaultActionGroupId = new SingleCombobox({
            darkTheme: true,
            title: "If the role is not specified, or the SAML/Oauth user entry does not include the Role Attribute, then this will be the default role given to a new Gluware user and the role can be modified in Gluware",
        });
        this._defaultActionGroupId.options = this._buildActionGroupList();
        this._defaultActionGroupId.setValue("7d144b88-27ee-4283-8da9-02302c615be3");

        // this._orgVisibility = new TextControl({
        //     darkTheme: true,
        //     label: "Organization Visibility Attribute"
        // });

        // this._defaultOrgVisibility = new InputRadioControl({
        //     darkTheme: true,
        //     horizontal: true,
        //     options: [{
        //             label: "All",
        //             tooltip: "All",
        //             value: "all"
        //         },
        //         {
        //             label: "Some",
        //             tooltip: "some",
        //             value: "some"
        //         },
        //         {
        //             label: "Home Organization",
        //             tooltip: "Home Organization",
        //             value: "home"
        //         }
        //     ],
        //     value: "all"
        // });

        this._userManagementContainer.appendChild(this._samlUsersOnly._renderer._rootElem);
        this._userManagementContainer.appendChild(
            this._samlDisableLocalLoginPage._renderer._rootElem
        );
        this._userManagementContainer.appendChild(
            this._renderFormPair(
                "Default Role",
                "If the role is not specified, or the SAML/Oauth user entry does not include the Role Attribute, then this will be the default role given to a new Gluware user and the role can be modified in Gluware",
                this._defaultActionGroupId
            )
        );
        this._userManagementContainer.appendChild(
            this._renderFormPair(
                "Role Attribute",
                "Optional SAML/Oauth attribute used to set the role; for example, memberOf. If Role Attribute is assigned, the role cannot be modified in Gluware",
                this._actionGroup
            )
        );
        this._userManagementContainer.appendChild(
            this._renderFormPair(
                "Username Attribute",
                "The SAML/Oauth attribute name where the username is stored in a user entry. Additional entries can be used if proxies are needed to access a device",
                this._userNameAttr,
                "The SAML/Oauth attribute name where the username is stored in a user entry. Additional entries can be used if proxies are needed to access a device"
            )
        );
        this._userManagementContainer.appendChild(
            this._renderFormPair(
                "Email Attribute",
                "The SAML/Oauth attribute that contains the user's email address; for example, mail.",
                this._email
            )
        );
        this._userManagementContainer.appendChild(
            this._renderFormPair(
                "First Name Attribute",
                "The SAML/Oauth attribute that contains the user’s first name",
                this._first
            )
        );
        this._userManagementContainer.appendChild(
            this._renderFormPair(
                "Last Name Attribute",
                "The SAML/Oauth attribute that contains the user’s last name",
                this._last
            )
        );
        // this._userManagementContainer.appendChild(this._renderFormPair("Organization Visibility Attribute", "Organization Visibility Attribute", this._orgVisibility));
        // this._userManagementContainer.appendChild(this._renderFormPair("Defaut Organization Visibility", "Defaut Organization Visibility", this._defaultOrgVisibility));

        this._userMgmtSection = this._createSection(this._userManagementContainer, {
            title: "User Management",
            className: "user-mgmt-section",
            bordered: true,
        });

        this._registerUserMgmtViewListeners();

        this._mainContainer.appendChild(this._userMgmtSection);
    }

    _createOauthUserManagementView() {
        this._oauthUserManagementContainer = document.createElement("div");
        this._oauthUserManagementContainer.classList.add("user-management-form");

        this._oauthUsersOnly = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Disable creation of local users",
            title: "Limits new users to only those in SAML/Oauth. Any existing users remain",
            disabled: false,
        });
        this._oauthDisableLocalLoginPage = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Disable local login page",
            title: "Disables the login page navigation through direct link.",
            disabled: false,
        });

        this._oauthUserNameAttr = new TextControl({
            darkTheme: true,
            label: "Username Attribute",
            title: "The SAML/Oauth attribute name where the username is stored in a user entry. Additional entries can be used if proxies are needed to access a device",
        });

        this._oauthEmail = new TextControl({
            darkTheme: true,
            label: "Email Attribute",
            title: "The SAML/Oauth attribute that contains the user's email address; for example, mail.",
        });

        this._oauthFirst = new TextControl({
            darkTheme: true,
            label: "First Name Attribute",
            title: "The SAML/Oauth attribute that contains the user’s first name",
        });

        this._oauthLast = new TextControl({
            darkTheme: true,
            label: "Last Name Attribute",
            title: "The SAML/Oauth attribute that contains the user’s last name",
        });

        this._oauthActionGroup = new TextControl({
            darkTheme: true,
            label: "Role Attribute",
            title: "Optional SAML/Oauth attribute used to set the role; for example, memberOf. If Role Attribute is assigned, the role cannot be modified in Gluware",
        });

        this._oauthDefaultActionGroupId = new SingleCombobox({
            darkTheme: true,
        });
        this._oauthDefaultActionGroupId.options = this._buildActionGroupList();
        this._oauthDefaultActionGroupId.setValue("7d144b88-27ee-4283-8da9-02302c615be3");

        // this._oauthOrgVisibility = new TextControl({
        //     darkTheme: true,
        //     label: "Organization Visibility Attribute"
        // });

        // this._oauthDefaultOrgVisibility = new InputRadioControl({
        //     darkTheme: true,
        //     horizontal: true,
        //     options: [{
        //             label: "All",
        //             tooltip: "All",
        //             value: "all"
        //         },
        //         {
        //             label: "Some",
        //             tooltip: "some",
        //             value: "some"
        //         },
        //         {
        //             label: "Home Organization",
        //             tooltip: "Home Organization",
        //             value: "home"
        //         }
        //     ],
        //     value: "all"
        // });

        this._oauthUserManagementContainer.appendChild(this._oauthUsersOnly._renderer._rootElem);
        this._oauthUserManagementContainer.appendChild(
            this._oauthDisableLocalLoginPage._renderer._rootElem
        );
        this._oauthUserManagementContainer.appendChild(
            this._renderFormPair(
                "Username Attribute",
                "The SAML/Oauth attribute name where the username is stored in a user entry. Additional entries can be used if proxies are needed to access a device",
                this._oauthUserNameAttr
            )
        );
        this._oauthUserManagementContainer.appendChild(
            this._renderFormPair(
                "Email Attribute",
                "The SAML/Oauth attribute that contains the user's email address; for example, mail.",
                this._oauthEmail
            )
        );
        this._oauthUserManagementContainer.appendChild(
            this._renderFormPair(
                "First Name Attribute",
                "The SAML/Oauth attribute that contains the user’s first name",
                this._oauthFirst
            )
        );
        this._oauthUserManagementContainer.appendChild(
            this._renderFormPair(
                "Last Name Attribute",
                "The SAML/Oauth attribute that contains the user’s last name",
                this._oauthLast
            )
        );
        this._oauthUserManagementContainer.appendChild(
            this._renderFormPair(
                "Role Attribute",
                "Optional SAML/Oauth attribute used to set the role; for example, memberOf. If Role Attribute is assigned, the role cannot be modified in Gluware",
                this._oauthActionGroup
            )
        );
        this._oauthUserManagementContainer.appendChild(
            this._renderFormPair(
                "Default Role",
                "If the role is not specified, or the SAML/Oauth user entry does not include the Role Attribute, then this will be the default role given to a new Gluware user and the role can be modified in Gluware",
                this._oauthDefaultActionGroupId
            )
        );
        // this._oauthUserManagementContainer.appendChild(this._renderFormPair("Organization Visibility Attribute", "Organization Visibility Attribute", this._oauthOrgVisibility));
        // this._oauthUserManagementContainer.appendChild(this._renderFormPair("Defaut Organization Visibility", "Defaut Organization Visibility", this._oauthDefaultOrgVisibility));

        this._oauthUserMgmtSection = this._createSection(this._oauthUserManagementContainer, {
            title: "User Management",
            className: "user-mgmt-section",
            bordered: true,
        });

        this._registerOauthUserMgmtViewListeners();

        this._mainContainer.appendChild(this._oauthUserMgmtSection);
    }

    _showSAMLAdvancedView() {
        this._samlAdvArea.setValue(
            JSON.stringify(_.omit(this._model._updatedSamlOptions, "advanced"), undefined, 4)
        );
        this._samlBasicContainer.classList.add("hide");
        this._samlAdvancedContainer.classList.remove("hide");
    }

    _showSAMLBasicView() {
        this._samlBasicContainer.classList.remove("hide");
        this._samlAdvancedContainer.classList.add("hide");
    }

    _showOauthAdvancedView() {
        this._oauthAdvArea.setValue(
            JSON.stringify(_.omit(this._model._updatedOauthOptions, "advanced"), undefined, 4)
        );
        this._oauthBasicContainer.classList.add("hide");
        this._oauthAdvancedContainer.classList.remove("hide");
    }

    _showOauthBasicView() {
        this._oauthBasicContainer.classList.remove("hide");
        this._oauthAdvancedContainer.classList.add("hide");
    }

    _createSAMLSection() {
        if (this._samlSection) {
            this._showSamlSection();
            return;
        }

        /* Create the SAML Section : Start */
        this._createSAMLSectionDOM();
        this._createSAMLBasicView();
        this._createSAMLAdvancedView();
        /* Create the SAML Section : End */

        /* Create the User Management section : Start */
        this._createUserManagementView();
        /* Create the User Management section : End */

        this._showSAMLBasicView();
    }

    _createOAuthSection() {
        if (this._oauthSection) {
            this._showOauthSection();
            return;
        }

        /* Create the OAuth Section : Start */
        this._createOauthSectionDOM();
        this._createOauthBasicView();
        this._createOauthAdvancedView(); // sagar
        /* Create the SAML Section : End */

        /* Create the User Management section : Start */
        this._createOauthUserManagementView();
        /* Create the User Management section : End */

        this._showOauthBasicView();
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /* SAML Common Listeners : Start */
    _ssoMechanismSelectChange(val, initial = false) {
        this._model._ssoMechanismChange(val);
        switch (val) {
            case "saml":
                if (this._model._updatedAuthSelection !== "saml" || initial === true) {
                    this._model._updatedAuthSelection = "saml";
                    this._model._loadSamlConfiguration().then(() => {
                        this._hideAllSections();
                        this._createSAMLSection();
                        this._updateSamlFormFromData();
                        this._validateSamlAndToggleActions();
                        return Promise.resolve();
                    });
                }
                break;
            case "oauth":
                if (this._model._updatedAuthSelection !== "oauth" || initial === true) {
                    this._model._updatedAuthSelection = "oauth";
                    this._model._loadOauthConfiguration().then(() => {
                        this._hideAllSections();
                        this._createOAuthSection();
                        this._updateOauthFormFromData();
                        this._validateOauthAndToggleActions();
                        return Promise.resolve();
                    });
                }
                break;
            case "disabled":
                if (this._model._updatedAuthSelection !== "disabled" || initial === true) {
                    this._model._updatedAuthSelection = "disabled";
                    // Sagar
                    this._hideAllSections();
                    this._validateSamlAndToggleActions();
                }
                break;
            default:
                break;
        }
    }

    _toggleActionButtons(state) {
        this._saveButton.setDisabled(!state);
        // this._cancelButton.setDisabled(!state);
    }

    _toggleCancelButton(state) {
        this._cancelButton.setDisabled(!state);
    }

    async _samlViewChangeChange(val) {
        if (val) {
            await this._model._setSamlAdvancedOptions(true);
            this._showSAMLAdvancedView();
        } else {
            this._model._setSamlBasicOptions();
            this._showSAMLBasicView();
        }
        this._validateSamlAndToggleActions();

        return Promise.resolve();
    }
    /* SAML Common Listeners : End */

    /* OAuth Common Listeners : Start */

    async _oauthViewChangeChange(val) {
        if (val) {
            await this._model._setOauthAdvancedOptions(true);
            this._showOauthAdvancedView();
        } else {
            this._model._setOauthBasicOptions();
            this._showOauthBasicView();
        }
        this._validateOauthAndToggleActions();

        return Promise.resolve();
    }

    /* OAuth Common Listeners : End */

    /* SAML Basic Listeners : Start */
    _onEntryPointFieldChange(value) {
        this._model._updatedSamlOptions.entryPoint = value;
        this._validateSamlAndToggleActions();
    }
    _onIssuerFieldChange(value) {
        this._model._updatedSamlOptions.issuer = value;
        this._validateSamlAndToggleActions();
    }
    _onNameIdFormatFieldChange(value) {
        this._model._updatedSamlOptions.nameIdFormat = value;
        this._validateSamlAndToggleActions();
    }
    _oncertFieldChange(value) {
        this._model._updatedSamlOptions.cert = value;
        this._validateSamlAndToggleActions();
    }
    _onDescripPvtKeyField(value) {
        this._model._updatedSamlOptions.decryptionPvk = value;
        this._validateSamlAndToggleActions();
    }
    _onLogoutUrlField(value) {
        this._model._updatedSamlOptions.logoutUrl = value;
        this._validateSamlAndToggleActions();
    }
    /* SAML Basic Listeners : End */

    /* OAuth Basic Listeners : Start */
    _onOauthAuthorizationURLFieldChange(value) {
        this._model._updatedOauthOptions.authorizationURL = value;
        this._validateOauthAndToggleActions();
    }
    _onOauthClientIdFieldChange(value) {
        this._model._updatedOauthOptions.clientID = value;
        this._validateOauthAndToggleActions();
    }
    _onOauthClientSecretFieldChange(value) {
        this._model._updatedOauthOptions.clientSecret = value;
        this._validateOauthAndToggleActions();
    }
    _onOauthPkceFieldChange(value) {
        this._model._updatedOauthOptions.pkce = value;
        this._validateOauthAndToggleActions();
    }
    _onOauthScopeFieldChange(value) {
        this._model._updatedOauthOptions.scope = value;
        this._validateOauthAndToggleActions();
    }
    _onOauthTokenURLFieldChange(value) {
        this._model._updatedOauthOptions.tokenURL = value;
        this._validateOauthAndToggleActions();
    }
    _onOauthUserProfileURLFieldChange(value) {
        this._model._updatedOauthOptions.userProfileURL = value;
        this._validateOauthAndToggleActions();
    }
    /* OAuth Basic Listeners : End */

    /* SAML Advanced Listeners : End */
    _onSamlAdvAreaChange(value) {
        this._model._updatedSamlOptions = this._model._getAdvancedOptions(JSON.parse(value));
        this._validateSamlAndToggleActions();
    }
    /* SAML Advanced Listeners : End */

    /* OAuth Advanced Listeners : Start */
    _onOauthAdvAreaChange(value) {
        this._model._updatedOauthOptions = this._model._getAdvancedOauthOptions(JSON.parse(value));
        this._validateOauthAndToggleActions();
    }
    /* OAuth Advanced Listeners : End */

    /* SAML User Management Listeners : Start */
    _onSamlUsersOnlyChange() {
        //this._toggleUserMgmtForm(value);
        this._updateUserDataOnChange();
    }
    _onSamlDisableLocalLoginPageChange() {
        this._updateUserDataOnChange();
    }
    _onUserNameAttrChange() {
        this._updateUserDataOnChange();
    }
    _onEmailChange() {
        this._updateUserDataOnChange();
    }
    _onFirstChange() {
        this._updateUserDataOnChange();
    }
    _onLastChange() {
        this._updateUserDataOnChange();
    }
    _onActionGroupChange() {
        this._updateUserDataOnChange();
    }
    _onDefaultActionGroupIdChange() {
        this._updateUserDataOnChange();
    }
    // _onOrgVisibilityChange() {
    //     this._updateUserDataOnChange();
    // }
    // _onDefaultOrgVisibility() {
    //     this._updateUserDataOnChange();
    // }
    /* SAML User Management Listeners : Start */

    /* OAuth User Management Listeners : Start */
    _onOauthUsersOnlyChange() {
        //this._toggleUserMgmtForm(value, false);
        this._updateUserDataOnChange(false);
    }
    _onOauthDisableLocalLoginPageChange() {
        this._updateUserDataOnChange(false);
    }
    _onOauthUserNameAttrChange() {
        this._updateUserDataOnChange(false);
    }
    _onOauthEmailChange() {
        this._updateUserDataOnChange(false);
    }
    _onOauthFirstChange() {
        this._updateUserDataOnChange(false);
    }
    _onOauthLastChange() {
        this._updateUserDataOnChange(false);
    }
    _onOauthActionGroupChange() {
        this._updateUserDataOnChange(false);
    }
    _onOauthDefaultActionGroupIdChange() {
        this._updateUserDataOnChange(false);
    }
    // _onOauthOrgVisibilityChange() {
    //     this._updateUserDataOnChange(false);
    // }
    // _onOauthDefaultOrgVisibility() {
    //     this._updateUserDataOnChange(false);
    // }
    /* OAuth User Management Listeners : Start */

    _submitSSOAction() {
        this._model._saveConfig().then(() => {
            if (_.get(this._model._updatedSamlConfig, "enabled", false)) {
                this._updateSamlFormFromData();
                this._validateSamlAndToggleActions();
            } else if (_.get(this._model._updatedOauthConfig, "enabled", false)) {
                this._updateOauthFormFromData();
                this._validateOauthAndToggleActions();
            } else {
                const btnState = this._checkIfDirty();
                this._toggleCancelButton(btnState);
                this._toggleActionButtons(btnState);
            }
        });
    }

    _cancelSamlAction() {
        this._model._cancelChanges();
        this._setSSOMechanismSelect();
    }

    /* Control change events : End */
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _toggleUserMgmtForm(value, isSaml = true) {
        let control = isSaml ? "saml" : "oauth";

        this[UserManagementControls["_userNameAttr"][control]].setDisabled(value);
        this[UserManagementControls["_email"][control]].setDisabled(value);
        this[UserManagementControls["_first"][control]].setDisabled(value);
        this[UserManagementControls["_last"][control]].setDisabled(value);
        this[UserManagementControls["_actionGroup"][control]].setDisabled(value);
        this[UserManagementControls["_defaultActionGroupId"][control]].setDisabled(value);
        // this[UserManagementControls["_orgVisibility"][control]].setDisabled(value);
        // this[UserManagementControls["_defaultOrgVisibility"][control]].setDisabled(value);
    }

    _hideAllSections() {
        this._hideSAMLSection();
        this._hideOauthSection();
    }

    _hideSAMLSection() {
        this._samlSection && this._samlSection.classList.add("hide");
        this._userMgmtSection && this._userMgmtSection.classList.add("hide");
    }

    _showSamlSection() {
        this._samlSection.classList.remove("hide");
        this._userMgmtSection.classList.remove("hide");
    }

    _hideOauthSection() {
        this._oauthSection && this._oauthSection.classList.add("hide");
        this._oauthUserMgmtSection && this._oauthUserMgmtSection.classList.add("hide");
    }

    _showOauthSection() {
        this._oauthSection.classList.remove("hide");
        this._oauthUserMgmtSection.classList.remove("hide");
    }

    _buildActionGroupList() {
        let actionGroupOptions = [];

        Object.values(this.model.myUserInfo.availableActionGroups)
            .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
            .forEach((groupEntity) => {
                actionGroupOptions.push({label: groupEntity.name, value: groupEntity.id});
            });
        return actionGroupOptions;
    }

    _updateUserDataOnChange(isSaml = true) {
        this._updateUserData(isSaml);
        if (isSaml) {
            this._validateSamlAndToggleActions();
        } else {
            this._validateOauthAndToggleActions();
        }
    }

    _updateUserData(isSaml = true) {
        let selector = "_updatedSamlConfig";
        if (!isSaml) {
            selector = "_updatedOauthConfig";
        }
        let control = isSaml ? "saml" : "oauth";
        if (!this._model[selector].mapping) {
            this._model[selector].mapping = {};
        }
        this._model[selector][`${control}UsersOnly`] =
            this[UserManagementControls["_samlUsersOnly"][control]].getValue() || false;
        this._model._updatedLocalLoginPageDisabled =
            this[UserManagementControls["_samlDisableLocalLoginPage"][control]].getValue() || false;
        this._model[selector].userNameAttr =
            this[UserManagementControls["_userNameAttr"][control]].getValue() || "";

        this._model[selector].mapping.email =
            this[UserManagementControls["_email"][control]].getValue() || "";
        this._model[selector].mapping.first =
            this[UserManagementControls["_first"][control]].getValue() || "";
        this._model[selector].mapping.last =
            this[UserManagementControls["_last"][control]].getValue() || "";
        this._model[selector].mapping.actionGroup =
            this[UserManagementControls["_actionGroup"][control]].getValue() || "";
        this._model[selector].defaultActionGroupId =
            this[UserManagementControls["_defaultActionGroupId"][control]].getValue();
        // this._model[selector].mapping.orgVisibility = this[UserManagementControls["_orgVisibility"][control]].getValue();
        // this._model[selector].defaultOrgVisibility = this[UserManagementControls["_defaultOrgVisibility"][control]].getValue();
    }

    _checkIfSamlDirty() {
        Object.assign(this._model._updatedSamlConfig, {
            options: this._model._SystemConfig._cleanSamlOptions(this._model._updatedSamlOptions),
        });

        this._isSamlDirty = !_.isEqual(this._model._samlConfigBase, this._model._updatedSamlConfig);

        return this._isSamlDirty;
    }

    _checkIfOauthDirty() {
        Object.assign(this._model._updatedOauthConfig, {
            options: this._model._SystemConfig._cleanOauthOptions(this._model._updatedOauthOptions),
        });

        this._isOauthDirty = !_.isEqual(
            this._model._oauthConfigBase,
            this._model._updatedOauthConfig
        );

        return this._isOauthDirty;
    }

    _checkIfLocalLoginDirty() {
        this._isLocalLoginDirty =
            this._model._updatedLocalLoginPageDisabled !== this._model._localLoginPageDisabledBase;

        return this._isLocalLoginDirty;
    }

    _checkIfDirty() {
        if (this._model._updatedAuthSelection !== this._model._authSelection) {
            return true;
        }

        if (this._checkIfSamlDirty()) {
            return true;
        }

        if (this._checkIfOauthDirty()) {
            return true;
        }

        if (this._checkIfLocalLoginDirty()) {
            return true;
        }

        return false;
    }

    _validateSamlAndToggleActions() {
        if (this._checkIfDirty()) {
            this._toggleCancelButton(true);
            if (_.get(this._model._updatedSamlConfig, "enabled", false)) {
                this._toggleActionButtons(this._validateSaml());
            } else {
                this._toggleActionButtons(true);
            }
        } else {
            this._toggleCancelButton(false);
            this._toggleActionButtons(false);
        }
    }

    _validateOauthAndToggleActions() {
        if (this._checkIfDirty()) {
            this._toggleCancelButton(true);
            if (_.get(this._model._updatedOauthConfig, "enabled", false)) {
                this._toggleActionButtons(this._validateOauth());
            } else {
                this._toggleActionButtons(true);
            }
        } else {
            this._toggleCancelButton(false);
            this._toggleActionButtons(false);
        }
    }

    _validateAdvancedOptions(options, type) {
        if (type === "saml") {
            if (this._model._getAdvancedOptions(JSON.parse(options))) {
                return true;
            }
            return false;
        } else if (type === "oauth") {
            if (this._model._getAdvancedOauthOptions(JSON.parse(options))) {
                return true;
            }
            return false;
        }
    }

    _updateSamlFormFromData() {
        this._samlConfigType.setValue(
            _.get(this._model._updatedSamlConfig, "options.advanced", false)
        );
        this._entryPointField.setValue(
            _.get(this._model._updatedSamlConfig, "options.entryPoint", "")
        );
        this._issuerField.setValue(_.get(this._model._updatedSamlConfig, "options.issuer", ""));
        this._nameIdFormatField.setValue(
            _.get(
                this._model._updatedSamlConfig,
                "options.nameIdFormat",
                "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress"
            )
        );
        this._certField.setValue(_.get(this._model._updatedSamlConfig, "options.cert", ""));

        this._descripPvtKeyCredField.setValue(
            _.get(this._model._updatedSamlConfig, "options.decryptionPvk", "")
        );

        if (_.get(this._model._updatedSamlConfig, "options.advanced", false)) {
            this._model._updatedSamlOptions =
                this._model._SystemConfig.convertBasicSamlOptionsToAdvanced(
                    this._model._updatedSamlOptions
                );
            this._samlAdvArea.setValue(
                JSON.stringify(_.omit(this._model._updatedSamlOptions, "advanced"), undefined, 4)
            );
        }

        this._samlUsersOnly.setValue(_.get(this._model._updatedSamlConfig, "samlUsersOnly", false));
        this._samlDisableLocalLoginPage.setValue(
            this._model._updatedLocalLoginPageDisabled || false
        );

        let userNameAttrVal = _.get(this._model._updatedSamlConfig, "userNameAttr", "");
        if (!_.trim(userNameAttrVal)) {
            _.set(this._model._updatedSamlConfig, "userNameAttr", "NameID");
            userNameAttrVal = _.get(this._model._updatedSamlConfig, "userNameAttr", "");
        }

        this._userNameAttr.setValue(userNameAttrVal);
        this._email.setValue(_.get(this._model._updatedSamlConfig, "mapping.email", ""));
        this._first.setValue(_.get(this._model._updatedSamlConfig, "mapping.first", ""));
        this._last.setValue(_.get(this._model._updatedSamlConfig, "mapping.last", ""));
        this._actionGroup.setValue(
            _.get(
                this._model._updatedSamlConfig,
                "mapping.actionGroup",
                "7d144b88-27ee-4283-8da9-02302c615be3"
            )
        );
        this._defaultActionGroupId.setValue(
            _.get(
                this._model._updatedSamlConfig,
                "defaultActionGroupId",
                "7d144b88-27ee-4283-8da9-02302c615be3"
            )
        );
        // this._orgVisibility.setValue(_.get(this._model._updatedSamlConfig, 'mapping.orgVisibility', ''));
        // this._defaultOrgVisibility.setValue(_.get(this._model._updatedSamlConfig, 'defaultOrgVisibility', 'all'));

        //this._toggleUserMgmtForm(_.get(this._model._updatedSamlConfig, "samlUsersOnly", false));

        this._samlViewChangeChange(
            _.get(this._model._updatedSamlConfig, "options.advanced", false)
        );
    }

    _updateOauthFormFromData() {
        this._oauthConfigType.setValue(
            _.get(this._model._updatedOauthConfig, "options.advanced", false)
        );
        this._oauthAuthorizationURLField.setValue(
            _.get(this._model._updatedOauthConfig, "options.authorizationURL", "")
        );
        this._oauthClientIdField.setValue(
            _.get(this._model._updatedOauthConfig, "options.clientID", "")
        );
        this._oauthClientSecretCredField.setValue(
            _.get(this._model._updatedOauthConfig, "options.clientSecret", "")
        );
        this._oauthPkceField.setValue(_.get(this._model._updatedOauthConfig, "options.pkce", ""));
        this._oauthScopeField.setValue(_.get(this._model._updatedOauthConfig, "options.scope", ""));
        this._oauthTokenURLField.setValue(
            _.get(this._model._updatedOauthConfig, "options.tokenURL", "")
        );
        this._oauthUserProfileURLField.setValue(
            _.get(this._model._updatedOauthConfig, "options.userProfileURL", "")
        );

        if (_.get(this._model._updatedSamlConfig, "options.advanced", false)) {
            this._model._updatedSamlOptions = this._model._getAdvancedOauthOptions(
                this._model._updatedOauthOptions
            );
            this._oauthAdvArea.setValue(
                JSON.stringify(_.omit(this._model._updatedOauthOptions, "advanced"), undefined, 4)
            );
        }

        this._oauthUsersOnly.setValue(
            _.get(this._model._updatedOauthConfig, "oauthUsersOnly", false)
        );
        this._oauthDisableLocalLoginPage.setValue(
            this._model._updatedLocalLoginPageDisabled || false
        );

        let userNameAttrVal = _.get(this._model._updatedOauthConfig, "userNameAttr", "");
        if (!_.trim(userNameAttrVal)) {
            _.set(this._model._updatedOauthConfig, "userNameAttr", "NameID");
            userNameAttrVal = _.get(this._model._updatedOauthConfig, "userNameAttr", "");
        }

        this._oauthUserNameAttr.setValue(userNameAttrVal);
        this._oauthEmail.setValue(_.get(this._model._updatedOauthConfig, "mapping.email", ""));
        this._oauthFirst.setValue(_.get(this._model._updatedOauthConfig, "mapping.first", ""));
        this._oauthLast.setValue(_.get(this._model._updatedOauthConfig, "mapping.last", ""));
        this._oauthActionGroup.setValue(
            _.get(
                this._model._updatedOauthConfig,
                "mapping.actionGroup",
                "7d144b88-27ee-4283-8da9-02302c615be3"
            )
        );
        this._oauthDefaultActionGroupId.setValue(
            _.get(
                this._model._updatedOauthConfig,
                "defaultActionGroupId",
                "7d144b88-27ee-4283-8da9-02302c615be3"
            )
        );
        // this._oauthOrgVisibility.setValue(_.get(this._model._updatedOauthConfig, 'mapping.orgVisibility', ''));
        // this._oauthDefaultOrgVisibility.setValue(_.get(this._model._updatedOauthConfig, 'defaultOrgVisibility', 'all'));

        /*
        this._toggleUserMgmtForm(
            _.get(this._model._updatedOauthConfig, "oauthUsersOnly", false),
            false
        );

       */

        this._oauthViewChangeChange(
            _.get(this._model._updatedOauthConfig, "options.advanced", false)
        );
    }

    _validateSaml() {
        let _isValid = false;
        this._samlErrors = [];
        const isSamlOnly = !!this._samlUsersOnly.getValue();
        const userNameAttr = _.get(this._model._updatedSamlConfig, "userNameAttr", ""),
            defaultActionGroupId = _.get(
                this._model._updatedSamlConfig,
                "defaultActionGroupId",
                ""
            ),
            entryPoint = _.get(this._model._updatedSamlOptions, "entryPoint", ""),
            issuer = _.get(this._model._updatedSamlOptions, "issuer", ""),
            cert = _.get(this._model._updatedSamlOptions, "cert", "");

        if (_.get(this._model._updatedSamlOptions, "advanced", false)) {
            if (
                (isSamlOnly || (_.trim(userNameAttr) && _.trim(defaultActionGroupId))) &&
                this._validateAdvancedOptions(
                    JSON.stringify(this._model._updatedSamlOptions),
                    "saml"
                )
            ) {
                _isValid = true;
            } else {
                return false;
            }
        } else {
            if (
                (isSamlOnly || (_.trim(userNameAttr) && _.trim(defaultActionGroupId))) &&
                _.trim(entryPoint) &&
                _.trim(issuer) &&
                _.trim(cert)
            ) {
                _isValid = true;
            } else {
                return false;
            }
        }

        return _isValid;
    }

    _validateOauth() {
        let _isValid = false;
        this._samlErrors = [];

        const userNameAttr = _.get(this._model._updatedOauthConfig, "userNameAttr", ""),
            defaultActionGroupId = _.get(
                this._model._updatedOauthConfig,
                "defaultActionGroupId",
                ""
            ),
            authorizationURL = _.get(this._model._updatedOauthOptions, "authorizationURL", ""),
            clientID = _.get(this._model._updatedOauthOptions, "clientID", ""),
            clientSecret = _.get(this._model._updatedOauthOptions, "clientSecret", ""),
            tokenURL = _.get(this._model._updatedOauthOptions, "tokenURL", ""),
            scope = _.get(this._model._updatedOauthOptions, "scope", ""),
            userProfileURL = _.get(this._model._updatedOauthOptions, "userProfileURL", "");

        if (_.get(this._model._updatedOauthOptions, "advanced", false)) {
            if (
                _.trim(userNameAttr) &&
                _.trim(defaultActionGroupId) &&
                this._validateAdvancedOptions(
                    JSON.stringify(this._model._updatedSamlOptions),
                    "oauth"
                )
            ) {
                _isValid = true;
            } else {
                return false;
            }
        } else {
            if (
                //values that cannot be empty
                _.trim(userNameAttr) &&
                _.trim(clientID) &&
                _.trim(clientSecret) &&
                _.trim(scope)
            ) {
                _isValid = true;
            } else {
                return false;
            }

            if (
                !this._GlURLRegex.test(authorizationURL) ||
                !this._GlURLRegex.test(tokenURL) ||
                !this._GlURLRegex.test(userProfileURL)
            ) {
                this._samlErrors.push({
                    key: "Gluware URL",
                    err: "A valid Gluware URL is required.",
                });
                return false;
            }
        }

        return _isValid;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = SingleSignOnRenderer;
